import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";

export class VehicleDocumentBus extends BaseBus {
    constructor(busObj: VehicleDocumentBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
    }

    CID(): any {
        return this.vehicleDocumentId;
    }
    setParentId(id: any) {
        this.vehicleId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        if (!CommonFunctions.hasGuidValue(this.CID())) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    public setFromForm(busObj: any) {
        super.setFromForm(busObj);
    }
    vehicleDocumentId: any;
    vehicleId: any;
    attachmentDetailFullName: string;
    shortDescription: string;
    note: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    document: any;
    confidential: boolean;
    ext: string;
}
